export default function MuiUseMediaQuery() {
  return {
    MuiUseMediaQuery: {
      defaultProps: {
        noSsr: true
      }
    }
  };
}
